var ViewportType;
(function (ViewportType) {
    ViewportType["STACK"] = "stack";
    ViewportType["ORTHOGRAPHIC"] = "orthographic";
    ViewportType["PERSPECTIVE"] = "perspective";
    ViewportType["VOLUME_3D"] = "volume3d";
    ViewportType["VOLUME_3D_NEXT"] = "volume3dNext";
    ViewportType["PLANAR_NEXT"] = "planarNext";
    ViewportType["VIDEO"] = "video";
    ViewportType["VIDEO_NEXT"] = "videoNext";
    ViewportType["WHOLE_SLIDE"] = "wholeSlide";
    ViewportType["WHOLE_SLIDE_NEXT"] = "wholeSlideNext";
    ViewportType["ECG"] = "ecg";
    ViewportType["ECG_NEXT"] = "ecgNext";
})(ViewportType || (ViewportType = {}));
export default ViewportType;
